import React from 'react';

interface WeChatQRSectionProps {
  /** compact：移动端横向紧凑条（二维码 72px + 右侧文字），桌面默认竖版卡片 */
  compact?: boolean;
}

/**
 * 登录弹窗左侧二维码区域 —— 按新稿（121:28 等 4 节点）还原：
 * section_1：188x238 / 渐变底 linear-gradient(180deg, #F8F8F8, #FFF) / 圆角 12px / 2px 白描边
 * 内部：132x132 二维码 + 「微信扫一扫/获取专属邀请码」(#1F1F1F) + 「加入 Bong Ai 交流社区」(45% 黑)
 * 邀请码可通过本二维码申请获得（对应右侧邀请码输入框占位文案）
 */
export const WeChatQRSection: React.FC<WeChatQRSectionProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <div
        className="flex items-center gap-3 rounded-xl px-4 py-3"
        style={{
          backgroundImage: 'linear-gradient(180deg, #F8F8F8 0%, #FFFFFF 100%)',
          border: '1px solid rgba(20, 20, 20, 0.06)',
        }}
      >
        <img
          src="/icons/login/qr-wechat.png"
          alt="微信二维码"
          className="h-[72px] w-[72px] shrink-0"
        />
        <div className="flex min-w-0 flex-col gap-1">
          <span className="text-[12px] font-semibold leading-[16px] text-[#1F1F1F]">
            微信扫一扫/获取专属邀请码
          </span>
          <span className="text-[11px] leading-[14px]" style={{ color: 'rgba(31, 31, 31, 0.45)' }}>
            加入 Bong Ai 交流社区
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col items-center shrink-0"
      style={{
        width: '188px',
        height: '238px',
        borderRadius: '12px',
        border: '2px solid #FFFFFF',
        backgroundImage: 'linear-gradient(180deg, #F8F8F8 0%, #FFFFFF 100%)',
      }}
    >
      <img
        src="/icons/login/qr-wechat.png"
        alt="微信二维码"
        style={{ width: '132px', height: '132px', marginTop: '28px' }}
      />
      <span
        className="whitespace-nowrap font-semibold"
        style={{ marginTop: '18px', fontSize: '11px', lineHeight: '12px', color: '#1F1F1F' }}
      >
        微信扫一扫/获取专属邀请码
      </span>
      <span
        className="whitespace-nowrap"
        style={{ marginTop: '12px', marginBottom: '24px', fontSize: '11px', lineHeight: '12px', color: 'rgba(31, 31, 31, 0.45)' }}
      >
        加入 Bong Ai 交流社区
      </span>
    </div>
  );
};
